import { DISCONNECTED_DEVICE_STATUS } from "constants/constants";

interface DeviceStatusFields {
	device_status?: string | null;
	partner_disconnected_at?: string | null;
	partner_association?: string | null;
}

// Returns the status key used for the CSS classes: "online", "offline", "disconnected", or
// undefined for a device that is not monitored.
export const getDeviceStatusKey = (device: DeviceStatusFields): string | undefined =>
	device.partner_disconnected_at ? DISCONNECTED_DEVICE_STATUS : device.device_status || undefined;

// Returns the text shown to the user, e.g. "online" or "Disconnected from myQ".
export const getDeviceStatusLabel = (device: DeviceStatusFields): string | undefined =>
	device.partner_disconnected_at
		? `Disconnected from ${device.partner_association || "partner"}`
		: device.device_status || undefined;
